import http from 'plugins/axios';

export default {
  getWhitelist(type, pair) {  // 新增pair参数
    const key = `trade-whitelist-${pair}-${type.toUpperCase()}`; // 动态替换BTC_USDT
    return http.get({
      url: '/admin/siteconf/get',
      params: { key, page: 1, size: 1000 }
    });
  },

  createWhitelist(type, value, pair) {  // 新增pair参数
    const key = `trade-whitelist-${pair}-${type.toUpperCase()}`;
    return http.post({
      url: '/admin/siteconf/create',
      dataType: 'form',
      data: {
        key,
        value: JSON.stringify(value)
      }
    });
  },

  updateWhitelist(type, value, pair) {  // 新增pair参数
    const key = `trade-whitelist-${pair}-${type.toUpperCase()}`;
    return http.post({
      url: '/admin/siteconf/update',
      dataType: 'form',
      data: {
        key,
        value: JSON.stringify(value)
      }
    });
  },

  getAllPair() {
    return http.get({
      url: '/admin/tradePair/allDisplay'
    });
  },
};
